import axios from 'axios';
import apiUrl from './index';

const pathUrls = {
	teakBooking: '/biro/teak/booking',
	checkInNow: '/checkInNow',
	checkOutNow: '/checkOutNow',
	extend: '/extend',
	series: '/series',
	cancelAttendance: '/cancelAttendance',
	edit: '/edit',
	delete: '/anonymize',
	deleteSeries: '/anonymizeSeries',
	forward: '/forward'
};

function getRelationId(relation) {
	if (!relation || typeof relation !== 'object') return relation;

	return relation._id ?? relation.id ?? relation;
}

function normalizeTeakEntity(teakEntity) {
	if (!teakEntity || typeof teakEntity !== 'object') return teakEntity;

	return {
		...teakEntity,
		office: getRelationId(teakEntity.office),
		area: getRelationId(teakEntity.area),
	};
}

function normalizeBooking(booking) {
	if (!booking || typeof booking !== 'object') return booking;

	return {
		...booking,
		office: getRelationId(booking.office),
		teakEntity: normalizeTeakEntity(booking.teakEntity),
	};
}

function normalizeBookingsResponse(response) {
	if (!response?.data) return response;

	return {
		...response,
		data: Array.isArray(response.data) ? response.data.map(normalizeBooking) : normalizeBooking(response.data),
	};
}

export async function findBookingsInRange(start, end, filters, skips, pageSize, sort, teakTypeIds) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + apiUrl.path.findInRange;

	const response = await axios({
		method: 'post',
		url: requestUrl,
		data: {
			start,
			end,
			filters,
			skips,
			pageSize,
			sort,
			teakTypeIds,
		},
	});

	return normalizeBookingsResponse(response);
}

export async function checkInNow(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.checkInNow;

	return axios({
		method: 'post',
		url: requestUrl,
		data: {
			checkInType: 'checkedIn',
		},
	});
}

export async function checkOutNow(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.checkOutNow;

	return axios({
		method: 'post',
		url: requestUrl,
	});
}

export async function extendTeakBooking(teakBookingId, until) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.extend;

	return axios({
		method: 'post',
		url: requestUrl,
		data: {
			until,
		},
	});
}

export async function editTeakBooking(teakBookingId, start, end, meetingName, attendees, teakEntity) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.edit;

	return axios({
		method: 'post',
		url: requestUrl,
		data: {
			start,
			end,
			meetingName,
			attendees,
			teakEntity,
		},
	});
}

export async function deleteAllRecurringBookings(teakBookingId, seriesId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.deleteSeries + '/' + seriesId;

	return axios({
		method: 'put',
		url: requestUrl,
	});
}
export async function deleteBooking(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.delete;

	return axios({
		method: 'put',
		url: requestUrl,
	});
}

export async function cancelBooking(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId;

	return axios({
		method: 'put',
		url: requestUrl,
	});
}

export async function cancelBookingSeries(seriesId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + pathUrls.series + '/' + seriesId;

	return axios({
		method: 'put',
		url: requestUrl,
	});
}

export async function cancelAttendance(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId + pathUrls.cancelAttendance;

	return axios({
		method: 'delete',
		url: requestUrl,
	});
}

/**
 *
 * @param {ID} teakBookingId = teak booking id
 * @returns Get booking data and entity data for specific id
 */
export async function getBooking(teakBookingId) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + teakBookingId;

	const response = await axios({
		method: 'get',
		url: requestUrl,
	});

	return normalizeBookingsResponse(response);
}

export async function proposalResponse(dataBookingId, type, payload) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + dataBookingId + '/' + type;

	return axios({
		method: 'post',
		url: requestUrl,
		data: {
			proposedNewTime: payload
		}
	});
}

export async function forwardBooking(bookingId, attendees) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + pathUrls.teakBooking + '/' + bookingId + pathUrls.forward;

	return axios({
		method: 'post',
		url: requestUrl,
		data: {
			attendees
		},
	});
}
